import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe, CommonModule, TitleCasePipe } from '@angular/common';
import { DeclarationsAuthService } from '../auth/declarations-auth.service';
import { NameMustMatchDirective, valuesMatch } from '../shared/name-must-match.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BlockCopyPasteDirective } from '../shared/block-copy-paste.directive';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';

@Component({
  selector: 'ad-fit-and-proper-declaration-ack-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">ACKNOWLEDGMENT</h4>
    </div>
    <div class="modal-body">
      <p>
        I, hereby confirm and declare that all the information provided herein to be, complete, true, and correct. I
        further understand and acknowledge that it is my personal responsibility to notify the licensed corporation as
        well as the SFC (for licenced individuals), immediately and in writing, in the event that any of the information
        contained herein changes.
      </p>
      <div class="mb-3">
        <label class="form-label">Please input your full name</label>
        <ejs-textbox
          [(ngModel)]="name"
          placeholder="Please input your full name"
          adBlockCopyPaste
          [adNameMustMatch]="nameToMatch"
          (change)="submitDisabled = !valuesMatch(data.name, nameToMatch)"
        ></ejs-textbox>
        <small class="form-text text-muted"
          >Must match your full name in the corporate directory ({{ nameToMatch }})</small
        >
      </div>
      <p class="mt-3">
        <strong>{{ data.declarationDate | date }}</strong>
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="handleClose()" [disabled]="submitDisabled">SUBMIT</button>
    </div>
  `,
  providers: [TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BlockCopyPasteDirective,
    CommonModule,
    DatePipe,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    NameMustMatchDirective,
    TextBoxModule
  ]
})
export class FitAndProperDeclarationAckDialogComponent implements OnInit {
  @Input() data: any = {};
  @Output() closeDialog = new EventEmitter<any>();

  protected name = '';
  protected submitDisabled = true;
  protected nameToMatch = '';
  protected valuesMatch = valuesMatch;

  constructor(
    public authService: DeclarationsAuthService,
    private titleCasePipe: TitleCasePipe
  ) {}

  public ngOnInit(): void {
    this.authService.getActiveAccount$().subscribe((account) => {
      this.nameToMatch = account?.name || '';
      this.submitDisabled = !valuesMatch(this.name, this.nameToMatch);
    });
  }

  public handleClose() {
    this.data.name = this.titleCasePipe.transform(this.name);
    this.closeDialog.emit(this.data);
  }
}
